import {getAnalytics} from 'firebase/analytics';

export const getOptionalAnalytics = (app, measurementId) => {
    if (!measurementId) return null;

    const {userAgent, maxTouchPoints} = navigator;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent)
        || (/Macintosh/.test(userAgent) && maxTouchPoints > 1);
    const isWebKit = /AppleWebKit/.test(userAgent);
    const isBrowser = /Safari\/|CriOS\/|FxiOS\/|EdgiOS\/|OPiOS\//.test(userAgent);

    // JRFD-LOG-1C: iOS embedded WebKit can pass Firebase's IndexedDB probe,
    // then give Installations an undefined database in its upgrade callback.
    // That asynchronous callback escapes try/catch around getAnalytics(). Skip
    // optional analytics before it registers the callback. This also covers
    // unbranded standalone iOS contexts; full browsers retain analytics.
    if (isIOS && isWebKit && !isBrowser) return null;

    return getAnalytics(app);
};
